export default __webpack_public_path__ + "static/kouraiScene3-ce4899f8fe72a381cbd9ec106cc78c74.mp4";